var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnboardingVistoria = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.869 194.145C156.209 194.145 190.533 190.309 190.533 185.577C190.533 180.845 156.209 177.009 113.869 177.009C71.5287 177.009 37.2051 180.845 37.2051 185.577C37.2051 190.309 71.5287 194.145 113.869 194.145Z",
    fill: "#E2E2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M189.84 15.855H20.16C15.5208 15.855 11.76 19.6158 11.76 24.255V127.407C11.76 132.046 15.5208 135.807 20.16 135.807H189.84C194.479 135.807 198.24 132.046 198.24 127.407V24.255C198.24 19.6158 194.479 15.855 189.84 15.855Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.861 16.2329H19.845C15.3914 16.2329 11.781 19.8433 11.781 24.2969V126.343C11.781 130.797 15.3914 134.407 19.845 134.407H189.861C194.315 134.407 197.925 130.797 197.925 126.343V24.2969C197.925 19.8433 194.315 16.2329 189.861 16.2329Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.781 114.716H197.925",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.781 95.0178H197.925",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.781 75.3198H197.925",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.781 55.6289H197.925",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.781 35.9309H197.925",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.901 16.2329V134.407",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.877 16.2329V134.407",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.853 16.2329V134.407",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8291 16.2329V134.407",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8049 16.2329V134.407",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0581 170.324L47.7821 174.678C47.2431 175.329 47.2291 176.267 47.7541 176.939L53.0111 183.701C53.3471 184.135 53.844 184.422 54.39 184.499L61.915 185.556C64.239 185.885 65.6461 182.924 63.5111 181.622C60.7601 179.942 58.9611 176.946 57.5611 174.125",
    fill: "#0E1010"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6061 113.624L56.6231 139.279L50.5891 170.541L58.9961 175.714L66.9761 148.12L67.1931 115.78",
    fill: "#0E1010"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.73 175.756L67.235 184.219C67.494 185.136 68.425 185.78 69.496 185.78L85.834 185.808C89.068 185.808 89.908 181.832 86.87 180.845C86.828 180.831 86.786 180.817 86.744 180.803C82.39 179.459 75.663 176.729 75.663 176.729",
    fill: "#0E1010"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8871 103.208C54.0401 105.175 53.8231 105.21 53.2841 107.282C51.7511 113.183 54.0961 118.188 57.6311 122.815C58.8561 124.425 61.6911 131.446 63.2451 136.171C63.9171 138.229 64.3021 140.364 64.3931 142.527L65.7371 175.749L75.9361 176.715C76.0971 172.109 79.6041 142.877 79.6041 142.877C79.7791 141.001 79.7861 139.111 79.6041 137.235L76.4751 104.09",
    fill: "#2D2D2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.372 43.6938H107.058C101.356 43.6938 96.7332 48.3165 96.7332 54.0188V168.574C96.7332 174.276 101.356 178.899 107.058 178.899H155.372C161.074 178.899 165.697 174.276 165.697 168.574V54.0188C165.697 48.3165 161.074 43.6938 155.372 43.6938Z",
    fill: "#A4F7D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.195 45.5768C162.19 45.5768 163.814 47.2008 163.814 49.1958V173.397C163.814 175.392 162.19 177.016 160.195 177.016H102.235C100.24 177.016 98.6162 175.392 98.6162 173.397V49.1958C98.6162 47.2008 100.24 45.5768 102.235 45.5768H160.195ZM160.195 43.6938H102.235C99.1972 43.6938 96.7332 46.1578 96.7332 49.1958V173.397C96.7332 176.435 99.1972 178.899 102.235 178.899H160.195C163.233 178.899 165.697 176.435 165.697 173.397V49.1958C165.697 46.1578 163.233 43.6938 160.195 43.6938Z",
    fill: "#010000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.092 51.9748H121.898C118.699 51.9748 116.102 49.3778 116.102 46.1788V45.5208H146.888V46.1788C146.888 49.3778 144.291 51.9748 141.092 51.9748Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M105.602 81.9628C105.602 81.9628 105.581 81.9628 105.574 81.9628C105.273 81.9558 105 81.7948 104.839 81.5428C103.838 79.9748 102.081 78.5048 102.067 78.4908C101.682 78.1688 101.626 77.6018 101.948 77.2168C102.27 76.8318 102.837 76.7758 103.222 77.0978C103.285 77.1538 104.559 78.2108 105.651 79.5758C106.757 78.3228 109.067 75.9988 112.665 73.6888C113.085 73.4158 113.645 73.5418 113.918 73.9618C114.191 74.3818 114.065 74.9418 113.645 75.2148C108.759 78.3508 106.358 81.5638 106.337 81.5988C106.169 81.8298 105.896 81.9628 105.609 81.9628H105.602Z",
    fill: "#00D38D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M151.431 71.533H123.872C119.894 71.533 116.669 74.7579 116.669 78.736C116.669 82.7141 119.894 85.939 123.872 85.939H151.431C155.409 85.939 158.634 82.7141 158.634 78.736C158.634 74.7579 155.409 71.533 151.431 71.533Z",
    fill: "#00D38D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.431 89.3828H123.872C119.894 89.3828 116.669 92.6077 116.669 96.5858C116.669 100.564 119.894 103.789 123.872 103.789H151.431C155.409 103.789 158.634 100.564 158.634 96.5858C158.634 92.6077 155.409 89.3828 151.431 89.3828Z",
    fill: "#00D38D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.431 107.233H123.872C119.894 107.233 116.669 110.458 116.669 114.436C116.669 118.414 119.894 121.639 123.872 121.639H151.431C155.409 121.639 158.634 118.414 158.634 114.436C158.634 110.458 155.409 107.233 151.431 107.233Z",
    fill: "#00D38D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.381 133.399H104.769V134.512H157.381V133.399Z",
    fill: "#00D38D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.381 136.325H104.769V137.438H157.381V136.325Z",
    fill: "#00D38D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.381 139.244H104.769V140.357H157.381V139.244Z",
    fill: "#00D38D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M157.381 142.17H104.769V143.283H157.381V142.17Z",
    fill: "#00D38D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.416 144.676H104.804V145.789H157.416V144.676Z",
    fill: "#00D38D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M157.416 147.595H104.804V148.708H157.416V147.595Z",
    fill: "#00D38D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.416 150.521H104.804V151.634H157.416V150.521Z",
    fill: "#00D38D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157.416 153.44H104.804V154.553H157.416V153.44Z",
    fill: "#00D38D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.49 100.128C105.49 100.128 105.469 100.128 105.462 100.128C105.161 100.121 104.888 99.9598 104.727 99.7078C103.726 98.1398 101.969 96.6698 101.955 96.6558C101.57 96.3338 101.514 95.7668 101.836 95.3818C102.158 94.9968 102.725 94.9408 103.11 95.2628C103.173 95.3188 104.447 96.3758 105.539 97.7408C106.645 96.4878 108.955 94.1638 112.553 91.8538C112.973 91.5808 113.533 91.7068 113.806 92.1268C114.079 92.5468 113.953 93.1068 113.533 93.3798C108.647 96.5158 106.246 99.7288 106.225 99.7638C106.057 99.9948 105.784 100.128 105.497 100.128H105.49Z",
    fill: "#00D38D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.533 118.496C106.533 118.496 106.512 118.496 106.505 118.496C106.204 118.489 105.931 118.328 105.77 118.076C104.769 116.508 103.012 115.038 102.998 115.024C102.613 114.702 102.557 114.135 102.879 113.75C103.201 113.365 103.768 113.309 104.153 113.631C104.216 113.687 105.49 114.744 106.582 116.109C107.688 114.856 109.998 112.532 113.596 110.222C114.016 109.949 114.576 110.075 114.849 110.495C115.122 110.915 114.996 111.475 114.576 111.748C109.69 114.884 107.289 118.097 107.268 118.132C107.1 118.363 106.827 118.496 106.54 118.496H106.533Z",
    fill: "#00D38D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.54 67.8159C78.456 67.8019 78.372 67.7879 78.295 67.7739C77.987 69.1249 77.735 70.4829 77.539 71.8549C77.483 72.2609 77.427 72.6739 77.28 73.0589C76.958 73.8779 76.314 73.9829 75.572 74.2489C74.928 74.4729 74.277 74.6899 73.626 74.8929C72.163 75.3549 70.686 75.7889 69.209 76.2159C67.823 76.6149 66.43 76.9999 65.037 77.3779C64.47 77.0839 64.197 76.4329 64.379 75.8239C65.023 73.6119 68.502 62.6079 68.537 60.8089C68.565 59.5699 68.439 58.3239 68.579 57.0919C68.936 53.8859 71.19 50.9809 74.193 49.7979C77.784 48.3769 82.481 49.4409 84.665 52.7449C85.386 53.8299 85.806 55.0759 86.226 56.3079C86.73 57.7919 87.234 59.2829 87.738 60.7669C87.787 60.8999 87.822 61.0679 87.724 61.1729C87.661 61.2429 87.563 61.2569 87.465 61.2639C87.038 61.3059 86.604 61.3199 86.177 61.2919C86.128 62.2299 86.247 66.5489 85.687 67.5989C84.875 69.1179 82.467 68.5019 81.116 68.2639C80.262 68.1169 79.401 67.9699 78.547 67.8229",
    fill: "#EBB990"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.329 55.8319C77.294 54.6559 77.609 53.6759 79.009 52.9199C80.108 52.3249 81.3609 52.0659 82.4879 51.5199C84.1539 50.7079 85.638 49.3919 85.631 47.5019C85.624 45.7239 84.434 43.8059 82.53 43.6729C81.858 43.6309 81.1859 43.7919 80.5139 43.7709C79.7579 43.7499 79.03 43.5049 78.281 43.4139C76.566 43.2039 74.774 43.8829 73.6189 45.1639C73.094 45.7519 72.66 46.4869 71.932 46.7949C71.414 47.0119 70.84 46.9769 70.28 47.0399C68.271 47.2499 67.907 48.1599 66.962 49.8119C66.787 50.1269 66.6049 50.4419 66.3389 50.6869C66.0169 50.9879 65.597 51.1489 65.212 51.3589C64.12 51.9469 63.2239 52.9479 62.8879 54.1449C62.5449 55.3419 62.804 56.7139 63.637 57.6309C62.923 58.5899 62.727 59.9129 63.133 61.0329C63.539 62.1529 64.54 63.0419 65.709 63.3149C65.954 63.3709 66.22 63.4129 66.402 63.5879C66.563 63.7419 66.619 63.9659 66.682 64.1759C67.389 66.3949 70.231 67.5359 72.429 67.0319C73.822 66.7099 74.9979 65.5969 75.3899 64.2249C74.4169 63.9729 73.416 63.7139 72.702 63.0139C72.1 62.4259 71.7779 61.5859 71.7149 60.7529C71.6659 60.1369 71.757 59.5069 72.044 58.9609C72.436 58.2259 73.1919 57.7009 74.0179 57.5959C74.8439 57.4909 75.712 57.8059 76.272 58.4219C76.433 58.5969 76.5869 58.8069 76.8179 58.8559C77.1119 58.9189 77.399 58.6879 77.504 58.4079C77.609 58.1279 77.5669 57.8199 77.518 57.5259C77.4199 56.9239 77.3359 56.3639 77.3149 55.8389L77.329 55.8319Z",
    fill: "#0E1010"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.03 73.3108L79.394 73.5838C83.426 76.5728 85.33 81.6548 84.252 86.5548L80.206 104.923L54.824 103.551L60.025 79.4288C60.081 79.2468 60.137 79.0718 60.2 78.8898C62.888 71.1618 72.464 68.4318 79.037 73.3038",
    fill: "url(#paint0_linear_31451_19796)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9839 88.3118L80.4019 97.0128L97.4959 83.4328C97.4959 83.4328 100.233 79.6248 101.745 80.0518C101.745 80.0518 104.636 76.9508 105.966 75.1938C106.379 74.6478 107.247 74.8228 107.408 75.4878C107.464 75.6978 107.429 75.9218 107.317 76.1108L104.062 81.4728C104.062 81.4728 105.56 81.4028 105.406 82.7818C105.406 82.7818 106.218 83.0058 105.994 83.9578C105.994 83.9578 106.393 84.7138 106.029 85.3018C105.672 85.8898 104.062 88.8228 100.184 90.1108C100.184 90.1108 84.3779 107.009 79.9119 107.24C75.4459 107.464 64.5469 91.1118 64.5469 91.1118L74.9909 88.3188",
    fill: "#EBB990"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0921 74.2418C63.6301 74.4658 63.1891 74.7528 62.7761 75.0958C60.7111 76.8178 59.9201 79.6248 60.7811 82.1658L64.6941 94.5978L77.2031 91.0768L73.1501 78.1758C73.0451 77.8328 72.9121 77.5038 72.7651 77.1958C71.1831 73.9828 67.2631 72.6878 64.1061 74.2348",
    fill: "url(#paint1_linear_31451_19796)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.482 57.2039C83.482 57.4489 83.286 57.6449 83.034 57.6449C82.789 57.6449 82.593 57.4489 82.593 57.1969C82.593 56.9519 82.789 56.7559 83.041 56.7559C83.286 56.7559 83.482 56.9519 83.482 57.2039Z",
    fill: "#000704"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7889 60.3049C82.8309 60.3049 82.8799 60.3189 82.9289 60.3539C83.4049 60.6689 83.9719 61.0679 84.5529 61.1659C84.8819 61.2219 84.7629 61.6979 84.4619 61.6979H84.4129C83.7899 61.5859 83.1739 61.1659 82.6629 60.8299C82.4179 60.6689 82.5719 60.3119 82.7959 60.3119",
    fill: "#DE8D47"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M162.708 59.5278L163.002 81.4378L99.2742 114.023L99.5612 92.9738L162.708 59.5278Z",
    fill: "#CBF4E4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M162.855 86.051L163.142 107.968L99.4211 140.553L99.7081 119.504L162.855 86.051Z",
    fill: "#CBF4E4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M99.2742 148.911L162.134 115.465L161.847 124.978L99.2742 157.276V148.911Z",
    fill: "#CBF4E4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31451_19796",
    x1: 54.824,
    y1: 87.9058,
    x2: 84.553,
    y2: 87.9058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31451_19796",
    x1: 61.2526,
    y1: 86.7163,
    x2: 74.8248,
    y2: 75.6904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnboardingVistoria);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/onboarding-vistoria.0c9b346371b38fd37c5719207da958b3.svg";